import { render, staticRenderFns } from "./DivisionTeacher.vue?vue&type=template&id=70f8df74"
import script from "./DivisionTeacher.vue?vue&type=script&lang=js"
export * from "./DivisionTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports